@if (loading) {
  <xui-loading-spinner></xui-loading-spinner>
}
@if (!loading) {
  <xui-error-message [errorMessage]="errorMessage"></xui-error-message>
}
@if (!loading && hasComment) {
  <div class="d-flex flex-column create-comment-form">
    <div class="row flex-grow-1">
      <div class="col-sm-12 mb-1">
        <xmed-transcribe [patientId]="patient.id" [commentId]="currentComment.id" (transcriptionResult)="onTextReceived($event)" *xuiPermissionRequired="'Clinical.Transcribe.Write'; condition: hasPatientDetails && hasComment"></xmed-transcribe>
      </div>
      <mat-divider></mat-divider>
      <div class="col-sm-12 mb-1 text-end">
        <div class="d-flex flex-row align-items-start justify-content-between">
          @if (currentComment.uploads.length) {
            <mat-list class="py-0">
              @for (upload of currentComment.uploads; track upload.id){
                <mat-list-item class="text-start">
                  <span (click)="appFileDownloader.openUpload()">{{ upload.fileName }}</span>
                  <div matListItemMeta class="mx-0">
                    <button mat-icon-button xuiConfirmationDialog [confirmMessage]="'Are you sure you want to delete this upload?'" (confirm)="appFileEditor.deleteAttachment()" [disabled]="appFileDownloader.processing()" *xuiPermissionRequired="'Clinical.Uploads.Delete'"><mat-icon>delete</mat-icon></button>
                  </div>
                  <xmed-file-downloader #appFileDownloader="libFileDownloader" [upload]="upload" (downloadRequested)="onDownloadRequested($event)"></xmed-file-downloader>
                  <xmed-file-editor #appFileEditor="libFileEditor" [upload]="upload" (deleteRequested)="onDeleteRequested($event)"></xmed-file-editor>
                </mat-list-item>
              }
            </mat-list>
          }
          <xmed-file-upload-button class="mt-2" *xuiPermissionRequired="'Clinical.Uploads.Write'; condition: hasPatientDetails" (uploadComplete)="onUploadComplete($event)" [patientId]="patient.id" [commentId]="currentComment.id" [tags]="tags" [uploadType]="'patient'">Add Uploads</xmed-file-upload-button>
        </div>
      </div>
      <div class="col-sm-12 mb-1">
        <textarea xuiTextareaAutosize xuiTextareaJumptext xuiTextareaHidpiRenderer
          [(ngModel)]="currentComment.comment.text" (ngModelChange)="onModelChange($event)"
          [jumpTextTarget]="currentComment.commentTemplate.commentTemplate.jumpTarget" [rows]="13"
          [style.background-color]="currentComment.commentType.color" class="draft-custom-form-control jump-text-container" >
        </textarea>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 d-flex flex-row justify-content-between align-items-center">
        <span class="mat-card-subtitle">{{currentComment.lastModifiedDate | date:'yyyy-MM-dd HH:mm'}}</span>
        <span class="mat-card-subtitle">{{currentComment.lastModifiedUser.firstName}} {{currentComment.lastModifiedUser.surname}}</span>
      </div>
    </div>
  </div>
}
